import React from 'react';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';
import { cn } from '../../lib/utils';
import { useTenant } from '../../contexts/TenantContext';

interface MarketingLayoutProps {
  children: React.ReactNode;
  className?: string;
  mainClassName?: string;
}

export const MarketingLayout: React.FC<MarketingLayoutProps> = ({ children, className, mainClassName }) => {
  const { colorMode, brand, activeBrandId } = useTenant();
  const theme = activeBrandId || 'minimal';
  const isDark = colorMode === 'dark';

  return (
    <div className={cn(
      "min-h-screen font-sans flex flex-col transition-colors duration-300 bg-white text-black dark:bg-black dark:text-white selection:bg-brand-primary/20",
      className
    )}>
      <PublicHeader />
      
      <main className={cn(
        "flex-grow flex flex-col border-x-[8px] md:border-x-[12px] border-black dark:border-white max-w-[1400px] mx-auto w-full bg-white dark:bg-black pt-20",
        mainClassName
      )}>
        {children}
      </main>

      <PublicFooter />
    </div>
  );
};
